import React, { useEffect, useCallback } from "react";
import { JobObject } from "@amzn/squad-front-end-shared-react-components";
import { LoadingState } from "../../http";
import useHttpRequest from "../../http/useHttpRequest";
import { MetricsState } from "../../logging";
import { GetSingleWorkflowResponseDto } from "./find-workflow-response.dto";
import { BrowserRouter } from "react-router-dom";
import { Icon, Link } from "@amzn/awsui-components-react-v3";
import { downloadFile } from "../utils/downloadFiles";
import styles from "./myjobs.module.css";

export const DOWNLOAD_LINK_TEXT_DEFAULT = "Download";

export interface DownloadLinkProps {
  metrics: MetricsState;
  job: JobObject;
  apiUrl: string;
}

export const DownloadLink = (properties: DownloadLinkProps): JSX.Element => {
  const { loadingState, data, error, sendRequest } = useHttpRequest<
    GetSingleWorkflowResponseDto
  >("singleJobFetch", {
    config: properties.metrics.config,
  });

  const singleWorkFlow = useCallback(() => {
    sendRequest({
      url: `${properties.apiUrl}/${properties.job.name.toLowerCase()}/${
        properties.job.instanceId
      }?employeeId=${properties.job.ownerId}`,
      method: "GET",
    });
  }, [sendRequest]);

  useEffect(() => {
    if (loadingState === LoadingState.RESOLVED && data) {
      if (
        properties.job.name == "CONVERT_UNAPPROVED_POSITIONS" &&
        data.workflow.customAttributes.errorUrl
      ) {
        downloadFile(data.workflow.customAttributes.errorUrl);
      } else if (
        properties.job.name == "EXPORT" &&
        data.workflow.customAttributes.csvUrl
      ) {
        downloadFile(data.workflow.customAttributes.csvUrl);
      }
    }
  }, [loadingState, data, sendRequest]);

  return (
    <BrowserRouter>
      <div className={styles["job-download-link"]}>
        <Link href="#" onFollow={() => singleWorkFlow()}>
          {DOWNLOAD_LINK_TEXT_DEFAULT}
          <Icon name="download"></Icon>
        </Link>
      </div>
    </BrowserRouter>
  );
};
